export default "__VITE_ASSET__Djl7iJmI__"